import React from 'react';
import {
  Box,
  Flex,
  Heading,
  Button,
  HStack,
  IconButton,
  useDisclosure,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  VStack,
  Container,
  useBreakpointValue,
  Image,
} from '@chakra-ui/react';
import { HamburgerIcon } from '@chakra-ui/icons';
import { motion } from 'framer-motion';
import { FaFistRaised, FaSignInAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const MotionBox = motion(Box);

export const LandingHeader = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const isMobile = useBreakpointValue({ base: true, lg: false });

  const navItems = [
    // { label: 'Events', href: '#events' },
    // { label: 'Fighters', href: '#fighters' },
    // { label: 'About', href: '#about' },
    // { label: 'Contact', href: '#contact' },
  ];

  const scrollToSection = (href) => {
    if (href.startsWith('#')) {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    onClose();
  };

  const handleAuthClick = () => {
    navigate('/auth');
  };

  return (
    <MotionBox
      position="fixed"
      top={0}
      left={0}
      right={0}
      zIndex={1000}
      bg="blackAlpha.900"
      backdropFilter="blur(10px)"
      borderBottom="1px solid"
      borderColor="dark.700"
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      <Container maxW="7xl">
        <Flex h={20} alignItems="center" justifyContent="space-between">
          {/* Logo */}
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <HStack spacing={3} cursor="pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
              <Image
                src="/logo.png"
                alt="RCF"
                maxW="250px"
                objectFit="contain"
              />
            </HStack>
          </motion.div>

          {/* Desktop Navigation */}
          {!isMobile && (
            <HStack spacing={8}>
              {navItems.map((item) => (
                <Button
                  key={item.label}
                  variant="ghost"
                  color="gray.300"
                  fontWeight="medium"
                  _hover={{
                    color: 'white',
                    transform: 'translateY(-2px)',
                  }}
                  onClick={() => scrollToSection(item.href)}
                  transition="all 0.2s"
                >
                  {item.label}
                </Button>
              ))}
            </HStack>
          )}

          {/* CTA Buttons */}
          <HStack spacing={4}>
            {!isMobile && (
              <Button
                variant="outline"
                borderColor="brand.500"
                color="brand.500"
                _hover={{
                  bg: 'brand.500',
                  color: 'white',
                  transform: 'translateY(-2px)',
                  boxShadow: 'lg',
                }}
                leftIcon={<FaFistRaised />}
                onClick={handleAuthClick}
                transition="all 0.2s"
              >
                Vote Now
              </Button>
            )}

            <Button
              colorScheme="brand"
              leftIcon={<FaSignInAlt />}
              _hover={{
                transform: 'translateY(-2px)',
                boxShadow: '0 10px 20px rgba(239, 68, 68, 0.4)',
              }}
              onClick={handleAuthClick}
              transition="all 0.2s"
            >
              Sign In
            </Button>

            {/* Mobile Menu Button */}
            {isMobile && (
              <IconButton
                icon={<HamburgerIcon />}
                variant="ghost"
                color="white"
                aria-label="Open menu"
                onClick={onOpen}
                _hover={{
                  bg: 'whiteAlpha.200',
                }}
              />
            )}
          </HStack>
        </Flex>
      </Container>

      {/* Mobile Drawer */}
      <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent bg="dark.800" borderLeft="1px solid" borderColor="dark.700">
          <DrawerCloseButton color="white" />
          <DrawerHeader>
            <HStack spacing={3}>
              <Image
                src="/logo.png"
                alt="RCF"
                height={8}
                maxW="120px"
                objectFit="contain"
              />
            </HStack>
          </DrawerHeader>

          <DrawerBody>
            <VStack spacing={6} align="stretch" pt={8}>
              {navItems.map((item) => (
                <Button
                  key={item.label}
                  variant="ghost"
                  color="gray.300"
                  fontWeight="medium"
                  size="lg"
                  justifyContent="flex-start"
                  _hover={{
                    color: 'white',
                    bg: 'whiteAlpha.100',
                  }}
                  onClick={() => scrollToSection(item.href)}
                >
                  {item.label}
                </Button>
              ))}

              <Box pt={4}>
                <Button
                  variant="outline"
                  borderColor="brand.500"
                  color="brand.500"
                  size="lg"
                  w="full"
                  leftIcon={<FaFistRaised />}
                  onClick={handleAuthClick}
                  _hover={{
                    bg: 'brand.500',
                    color: 'white',
                  }}
                  mb={4}
                >
                  Vote Now
                </Button>
              </Box>
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </MotionBox>
  );
};
